import React from 'react';
import Rate from '../../Rate';
import moment from 'moment';

const DriverEmailDetails = ({ policy, rate }) => {
	const { policyNumber } = policy;
	const { transactionDate, policyEffectiveDate, policyExpirationDate, email } = rate;
	const { action, name } = email;

	return (
		<table>
			<tr>
				<td>Policy Number: {policyNumber}</td>
				<td>
					<div>
						Effective Policy Period: {moment(transactionDate).format('L')} to {moment(policyExpirationDate).format('L')}
					</div>
					<div>
						Current Policy Period: {moment(policyEffectiveDate).format('L')} to {moment(policyExpirationDate).format('L')}
					</div>
				</td>
			</tr>
			<tr>
				<td colSpan='2'>
					<Rate rate={rate} />
				</td>
			</tr>
			<tr>
				<td colSpan='2'>
					Driver {action}: {name}
				</td>
			</tr>
		</table>
	);
};

export default DriverEmailDetails;
